import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { buildStoreRedirectURLForPackage } from '../util/store';

@Component({
  selector: 'strfrnt-cart-redirect',
  templateUrl: './cart-redirect.component.html',
  styleUrls: ['./cart-redirect.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CartRedirectComponent implements OnInit {
  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.params.subscribe(({ marketId, packageId }) => {
      window.location.href = buildStoreRedirectURLForPackage(marketId, packageId, 'direct_package_link');
    });
  }
}
